import ReactGA from 'react-ga';

interface AnalyticsBaseEvent {
    category: string, action: string
}

const useAnalyticsEvent = ({ category, action }: AnalyticsBaseEvent) => {
  return (label: string) => {
    ReactGA.event({
      category,
      action,
      label
    });
  };
};

export default useAnalyticsEvent;
